/** What the character is doing. */
export type VoiceAgentState = 'listening' | 'thinking' | 'speaking';

/**
 * Why a spoken conversation is not happening.
 *
 * Three different problems with three different answers: `blocked` is fixed in
 * the browser's own settings, `connect` is worth another try, and `dropped`
 * happened to a call that was working a second ago.
 */
export type VoiceFailure = 'blocked' | 'connect' | 'dropped';

/**
 * Whether the microphone was refused rather than merely unreachable.
 *
 * The browser, the operating system and an enterprise policy all report a
 * refusal the same way, and none of them is fixed by trying again — which is
 * why this is the one failure the screen answers with instructions instead of a
 * retry.
 */
export function isMicrophoneBlocked(error: unknown): boolean {
  return error instanceof Error && error.name === 'NotAllowedError';
}
